export function getPdfPaths(schemeCode: string) {
  const mappedSchemes = {
    WD9: {
      folder: 'ao',
      termsAndConditions: 'AO_TCNT_0822_98.pdf',
      ipid: 'AO_TSWIP_1025_80_100.pdf',
    },
    WD6: {
      folder: 'ao',
      termsAndConditions: 'AO_TCNT_0822_98.pdf',
      ipid: 'AO_TSWIP_1025_80_100.pdf',
    },
    WD5: {
      folder: 'ao',
      termsAndConditions: 'AO_TCIMNT_1022_16.pdf',
      ipid: 'AO_NTSWIP_1025_62_100.pdf',
    },
    W1F: {
      folder: 'whirlpool',
      termsAndConditions: 'BEK_WTCOLR_0625_70_100.pdf',
      ipid: 'WHI_IPIMIN_0223_43_100.pdf',
    },
    W1G: {
      folder: 'whirlpool',
      termsAndConditions: 'BEK_WTCOLR_0625_70_100.pdf',
      ipid: 'WHI_IPIMIN_0223_43_100.pdf',
    },
    W1H: {
      folder: 'whirlpool',
      termsAndConditions: 'BEK_WTCOLR_0625_70_100.pdf',
      ipid: 'WHI_IPIMIN_0223_43_100.pdf',
    },
    W1J: {
      folder: 'whirlpool',
      termsAndConditions: 'BEK_WTCOLR_0625_70_100.pdf',
      ipid: 'WHI_IPIMIN_0223_43_100.pdf',
    },
    YQ9: {
      folder: 'whirlpool',
      termsAndConditions: 'BEK_WTCOLR_0625_70_100.pdf',
      ipid: 'WHI_IPIMIN_0223_43_100.pdf',
    },
    ZW7: {
      folder: 'marks-electrical',
      termsAndConditions: 'MAR_WTCINIM_0923_97_100.pdf',
      ipid: 'HUG_IPWG_1025_90_100.pdf',
    },
    '5FT': {
      folder: 'whirlpool',
      termsAndConditions: 'BEK_WTCOLR_0625_70_100.pdf',
      ipid: 'WHI_IPIMIN_0223_43_100.pdf',
    },
    '5FX': {
      folder: 'whirlpool',
      termsAndConditions: 'BEK_WTCOLR_0625_70_100.pdf',
      ipid: 'WHI_IPIMIN_0223_43_100.pdf',
    },
    '5FY': {
      folder: 'whirlpool',
      termsAndConditions: 'BEK_WTCOLR_0625_70_100.pdf',
      ipid: 'WHI_IPIMIN_0223_43_100.pdf',
    },
  };

  schemeCode = (schemeCode || '').toUpperCase();

  return {
    termsAndConditions: `${mappedSchemes[schemeCode]?.folder || 'general'}/${
      mappedSchemes[schemeCode]?.termsAndConditions || 'WHI_WTCIM_0323_78.pdf'
    }`,
    ipid: `${mappedSchemes[schemeCode]?.folder || 'general'}/${
      mappedSchemes[schemeCode]?.ipid || 'DG_IIPM_1025_17_100.pdf'
    }`,
  };
}
